import { useState } from "react";

interface AvatarProps {
  src?: string | null;
  alt?: string;
  size?: number;
  className?: string;
}

export function Avatar({ src, alt = "", size = 40, className = "" }: AvatarProps) {
  const [error, setError] = useState(false);

  if (!src || error) {
    return (
      <div
        className={`rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-400 ${className}`}
        style={{ width: size, height: size }}
      >
        <svg
          width={size * 0.6}
          height={size * 0.6}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>
    );
  }

  // Fixed-size circular crop container so the avatar renders as a perfect
  // circle regardless of source aspect ratio. `compressForAvatar` preserves
  // aspect; without this wrapper a non-square pet photo would render oblong.
  return (
    <div
      className={`rounded-full overflow-hidden flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={src}
        alt={alt}
        width={size}
        height={size}
        className="w-full h-full object-cover"
        onError={() => setError(true)}
      />
    </div>
  );
}
